import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component,
  Inject,
  ViewChild,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from '@infra/auth/auth.service';
import { NotificacaoModel } from '@app/data/notificacao/models'; 
import { NotificacaoRepository } from '@app/data/notificacao/notificacao.repository';
import { Campo, FormComponent } from '@components/form/form.component';
import { modal } from '@shared/alerts/modal/modal.alert';
import { currencyBRL } from '@shared/formatters';
import { NavService } from '@app/infra/nav/nav.service';

@Component({
  selector: 'app-detalhes-notificacao',
  templateUrl: './detalhes-notificacao.component.html',
  styleUrls: ['./detalhes-notificacao.component.scss'],
})
export class DetalhesNotificacaoComponent implements AfterContentChecked {

  public title = 'Detalhe Notificação - Portal do Cliente'
  public notificacao: NotificacaoModel | undefined;

  protected camposDadosDetalhes: Campo[] = [
    {
      name: 'valores',
      label: 'Valores',
      type: 'table',
      disabled: true,
      width: '100%',
      tableOptions: {
        items: [],
        colunas: [
          {
            name: 'chave',
            label: 'Campo Alterado',
          },
          {
            name: 'valorAntigo',
            label: 'Valor Antigo',
          },
          {
            name: 'valorNovo',
            label: 'Valor Novo',
          },
        ]
      }
    },
  ];

  @ViewChild('formDetalhes') formDetalhes: FormComponent | undefined;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: { id: string },
    private dialogRef: MatDialogRef<DetalhesNotificacaoComponent>,
    private changeDetector: ChangeDetectorRef,
    private notificacaoRepository: NotificacaoRepository,
    protected authService: AuthService,
    private navService: NavService
  ) {}

  /** Para evitar erros em ambiente de desenvolvimento */
  public ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }

  public ngOnInit(): void {
    this.notificacaoRepository
      .getByIdRequest<{ data: NotificacaoModel }>(this.data.id)
      .subscribe(({ data }) => {
        if (data) {
          this.formDetalhes?.load(data);
          this.notificacao = data;
        }
      });
  }
  
  public confirmarLeitura() {
    // Marca a notificação como lida
    this.notificacaoRepository.putNotificacao({
      codigoNotificacao: this.data.id
    }).subscribe({
      next: () => {
        this.navService.verificaQuantidadeNotificacoes();
        this.dialogRef.close(true);
      },
      error: () => {
        modal.fire({
          icon: 'error',
          title: `Erro ao marcar notificação como lida`,
          html: 'Tente novamente mais tarde',
        });

        this.dialogRef.close(false);
      },
    });
  }

  protected onClose() {
    this.dialogRef.close(false);
  }
}
